export default {
  LIST_FETCHED: 'VOUCHERS_FETCHED',
  LIST_LOAD: 'VOUCHERS_LOAD',
  TEMPLATES_FETCHED: 'VOUCHERS_TEMPLATES_FETCHED',
  TEMPLATES_LOAD: 'VOUCHERS_TEMPLATES_LOAD',
  ITEM_DETAIL: 'VOUCHERS_DETAIL',
  BUTTON_LOAD: 'VOUCHERS_BUTTON_LOAD',
};
